module.exports = __webpack_public_path__ + "static/EnmTX_BosGideon_L_A_cl-d9be4d16d95cb7f9d1945b3731357c21.gif";